import './App.css';

const targets = [
  {
    id: 'mchatai',
    name: 'mchatai.com',
    icon: 'm',
    description: 'Host on your mChatAI subdomain. Included with your plan.',
    note: 'Free: 25 MB / 1 GB bandwidth. Upgrade for more.',
    action: 'Deploy',
    free: true,
  },
  {
    id: 'vercel',
    name: 'Vercel',
    icon: '▲',
    description: 'Deploy to Vercel for free edge hosting with 100 GB bandwidth. Best for production sites.',
    note: 'Free tier: 100 GB bandwidth, custom domains, automatic HTTPS.',
    action: 'Deploy to Vercel',
    free: true,
    external: true,
  },
  {
    id: 'netlify',
    name: 'Netlify',
    icon: '◈',
    description: 'Deploy to Netlify for free hosting with 100 GB bandwidth and form handling.',
    note: 'Free tier: 100 GB bandwidth, 125k serverless functions/mo.',
    action: 'Deploy to Netlify',
    free: true,
    external: true,
  },
  {
    id: 'github-pages',
    name: 'GitHub Pages',
    icon: '⬡',
    description: 'Push to a GitHub repo and serve via GitHub Pages. Free for public repos.',
    note: 'Free: unlimited bandwidth for public repos.',
    action: 'Push to GitHub',
    free: true,
    external: true,
  },
  {
    id: 'firebase',
    name: 'Firebase Hosting',
    icon: '🔥',
    description: 'Deploy directly to your own Firebase project. Full control, pay-as-you-go.',
    note: 'Free tier: 1 GB storage, 10 GB bandwidth/mo.',
    action: 'Deploy to Firebase',
    free: true,
    external: true,
  },
  {
    id: 'download',
    name: 'Download Bundle',
    icon: '↓',
    description: 'Download your project as a zip file. Deploy anywhere you want.',
    note: 'HTML/CSS/JS bundle ready for any static host.',
    action: 'Download .zip',
    free: true,
  },
];

export default function DeployPage() {
  return (
    <div style={{ maxWidth: 700, margin: '40px auto', padding: '0 24px' }}>
      <h1 style={{ fontSize: '1.5rem', color: '#f8fafc', marginBottom: 8 }}>Deploy Anywhere</h1>
      <p style={{ color: '#94a3b8', fontSize: '0.9rem', marginBottom: 32 }}>
        mChatAI+ builds it. You choose where to host it. Every option below is free — we never lock you in.
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {targets.map((target) => (
          <div key={target.id} style={{
            background: '#1e293b', borderRadius: 14, padding: 20,
            border: target.id === 'mchatai' ? '1px solid #3b82f6' : '1px solid rgba(255,255,255,0.08)',
            display: 'flex', alignItems: 'center', gap: 16,
          }}>
            <div style={{
              width: 44, height: 44, borderRadius: 10, display: 'flex',
              alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem',
              background: target.id === 'mchatai' ? 'rgba(59,130,246,0.15)' : 'rgba(255,255,255,0.05)',
              color: target.id === 'mchatai' ? '#3b82f6' : '#94a3b8', flexShrink: 0,
            }}>
              {target.icon}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: '0.95rem', fontWeight: 600, color: '#f8fafc', marginBottom: 2 }}>
                {target.name}
                {target.free && (
                  <span style={{
                    marginLeft: 8, fontSize: '0.65rem', padding: '2px 8px', borderRadius: 8,
                    background: 'rgba(52,199,89,0.1)', color: '#4ade80', fontWeight: 500,
                  }}>FREE</span>
                )}
              </div>
              <div style={{ fontSize: '0.8rem', color: '#94a3b8', marginBottom: 2 }}>{target.description}</div>
              <div style={{ fontSize: '0.72rem', color: '#64748b' }}>{target.note}</div>
            </div>
            <button style={{
              padding: '8px 16px', borderRadius: 16, border: 'none', flexShrink: 0,
              background: target.id === 'mchatai' ? '#3b82f6' : '#f8fafc',
              color: target.id === 'mchatai' ? '#fff' : '#0f172a',
              fontSize: '0.8rem', fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit',
            }}>
              {target.action}
            </button>
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center', marginTop: 32, color: '#64748b', fontSize: '0.8rem' }}>
        Deploy targets are configured per-project in AIWizard. Build your app first, then deploy here.
        <br />All external hosts have their own free tiers — we don't charge anything for deploying elsewhere.
      </div>
    </div>
  );
}
